import React, { useMemo } from 'react'

import { TokenProps } from './index'
import { formatPrice } from 'utils'
import {
	Container,
	TokenIcon,
	Text,
} from './Token.styles'

export default function Token(
	{
		count,
		price,
		discount,
		countryCode,
		...props
	}: TokenProps,
) {
	const formattedPrice = useMemo(() => (
		typeof price === 'string'
			? price
			: `${formatPrice(Math.round(price * (100 - (discount || 0)) / 100))} ${countryCode === 'CA' ? '+ HST' : ''}`
	), [price, discount])

	return (
		<Container {...(props as any)}>
			<TokenIcon />
			<Text>
				<p className='top'>{count} resume token{count > 1 ? 's' : ''}</p><br />
				<p className='bottom'>{formattedPrice}</p>{discount && <p className='discount'>SAVE {discount}%</p>}
			</Text>
		</Container>
	)
}
